export default {
  punch_in: 'Punch In',
  punch_out: 'Punch Out',
  breaks_label: 'Breaks',
  no_break: 'No breaks',
  total_day_work_time: 'Total Day Work Time',
  planned_travel_time: 'Planned Travel Time',
  total_break: 'Total Break',
  total_worked: 'Total Worked',
  data_not_available: 'Data not available',
  weekly_summary: 'Weekly Summary',
  total_week_work_time: 'Total Week Work Time',
  total_week_planned_travel: 'Total Week Planned Travel',
  total_week_break: 'Total Week Break',
  total_week_worked: 'Total Week Worked',
  morning_start: 'Morning Start',
  morning_end: 'Morning End',
  afternoon_start: 'Afternoon Start',
  afternoon_end: 'Afternoon End',
  expected_hours: 'Expected Hours',
  break_duration: 'Break Duration',
  notes: 'Notes',
  cancel: 'Cancel',
  save: 'Save',
  export_excel: 'Export Excel',
  worked_days: 'Worked Days',
  non_worked_days: 'Non-Worked Days',

  // Punch details dialog
  punch_details_for: 'Punch Details for',
  all_punches_for_day: 'All punches for this day',
  no_punches_today: 'No punches today',
  punch_times_appear_here: 'Punch times will appear here when created',
  view_location: 'View Location',
  edit_punch: 'Edit Punch',
  delete_punch: 'Delete Punch',
  day_summary: 'Day Summary',
  worked: 'Worked',
  breaks: 'Breaks',
  travel: 'Travel',
  add_punch: 'Add Punch',

  // Punch types
  break_start: 'Break Start',
  break_end: 'Break End',

  // Punch editor
  punch_type: 'Punch Type',
  punch_type_required: 'Punch type is required',
  punch_date: 'Punch Date',
  punch_time: 'Punch Time',
  punch_date_time: 'Punch Date & Time',
  time_required: 'Time is required',
  invalid_time_format: 'Invalid time format (HH:MM)',
  comment: 'Comment',
  comment_placeholder: 'Add a comment about this punch...',
  location: 'Location',

  // Confirmations
  confirm_delete: 'Confirm Delete',
  confirm_delete_punch_message: 'Are you sure you want to delete the {type} punch at {time}?',

  // Success messages
  punch_updated_successfully: 'Punch updated successfully',
  punch_deleted_successfully: 'Punch deleted successfully',
  punch_created_successfully: 'Punch created successfully',
  bulk_operations_completed: 'Bulk operations completed successfully',
  punches_deleted_successfully: 'Punches deleted successfully',
  export_started: 'Export started',

  // Error messages
  error_updating_punch: 'Error updating punch',
  error_deleting_punch: 'Error deleting punch',
  error_creating_punch: 'Error creating punch',
  error_bulk_operations: 'Error performing bulk operations',
  error_deleting_punches: 'Error deleting punches',
  error_loading_activity: 'Error loading activity',
  error_exporting: 'Error exporting data',

  // Features
  location_feature_coming_soon: 'Location viewing feature coming soon',
}
